import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { OrderedMap } from "immutable";
import { defaultOnError } from "util/conditional/onError";
export const slicesToFilters = (searchParams) => {
  var _a;
  const newSearchParams = { ...searchParams };
  delete newSearchParams.slice;
  delete newSearchParams.sliceCol;
  if (searchParams.sliceCol && searchParams.slice) {
    const filters = (_a = newSearchParams.filters) != null ? _a : OrderedMap();
    newSearchParams.filters = filters.set(searchParams.sliceCol, [searchParams.slice]);
  }
  return newSearchParams;
};
const useFetchEntities = ({
  fetchKey,
  searchParams,
  fetchEntities,
  enabled,
  humanName,
  fetchOptions = {}
}) => {
  const { data, isInitialLoading, refetch, isError, error } = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: fetchKey,
    queryFn: () => defaultOnError(
      fetchEntities(slicesToFilters(searchParams)),
      `Fetching ${humanName} failed with status`,
      `Could not retrieve ${humanName}`
    ),
    enabled,
    placeholderData: keepPreviousData,
    ...fetchOptions
  });
  return {
    data,
    isInitialLoading,
    refetch,
    isError,
    error
  };
};
export default useFetchEntities;
